const state = {
  fullLoading: false, // 控制layout.vue里router-view loading的显示隐藏
  loadingText: "", // loading文字内容
  userInfo: null,
  menu: [],
  topIndex: 100
};

const mutations = {
  showFullLoading: (state) => {
    state.fullLoading = true;
  },
  closeFullLoading: (state) => {
    state.fullLoading = false;
  },
  changeLoadingText: (state, n) => {
    state.loadingText = n;
  },
  setUserInfo: (state, n) => {
    state.userInfo = n;
  },
  setMenu: (state, n) => {
    state.menu = n;
  },
  setTopIndex: (state, n) => {
    state.topIndex = n;
  }
};

const actions = {
  showFullLoading: ({ commit }, n) => {
    commit("showFullLoading");
    if (n) {
      commit("changeLoadingText", n);
    }
  },
  closeFullLoading: ({ commit }) => {
    commit("closeFullLoading");
  },
  updateLoginInfo: ({ commit }, n) => {
    commit("setUserInfo", n.userInfo);
    commit("setMenu", n.menu);
  },
  loginOut: ({ commit }) => {
    commit("setUserInfo", null);
    commit("setMenu", []);
  },
  showSetTopIndex: ({ commit }, n) => {
    commit('setTopIndex', n);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
